import * as e from "react";
const o = ({
  title: l,
  titleId: t,
  ...a
}) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": t,
    ...a
  },
  l ? /* @__PURE__ */ e.createElement("title", { id: t }, l) : null,
  /* @__PURE__ */ e.createElement("path", { d: "M13.862 10.469 21.147 2h-1.726l-6.326 7.353L8.042 2H2.215l7.64 11.12L2.215 22H3.94l6.68-7.765L15.958 22h5.828zm-9.299-7.17h2.652l12.206 17.46H16.77z" })
);
export {
  o as default
};
